export default {};



// WEBPACK FOOTER //
// ./src/components/generics/plus-minus-sign/plus-minus-sign.js